import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CourseInformation } from '../CompanyBuy.styles';
const CourseList = ({ courses, selectedCourse, setSelectedCourse }) => {
  const [courseSelected, setCourseSelected] = useState(false);

  const handleCourseChange = (e) => {
    const selectedCourseId = e.target.value;
    const fullCourse = courses.find(
      (course) => course?._id === selectedCourseId
    );
    setSelectedCourse(fullCourse);
    setCourseSelected(true);
  };

  return (
    <div>
      <div className="selectCourse">
        <label htmlFor="courseSelect">Select a Course:</label>
        <select
          id="courseSelect"
          value={selectedCourse?._id || ''}
          onChange={handleCourseChange}
          style={{ marginLeft: '10px', padding: '5px' }}
        >
          <option value="" disabled>
            -- Select a Course --
          </option>
          {courses?.map((course) => (
            <option key={course?._id} value={course?._id}>
              {course?.courseName}
            </option>
          ))}
        </select>
      </div>
      {courseSelected && (
        <CourseInformation>
          <h3>{selectedCourse?.courseName}</h3>
          <p>
            Expires In:{' '}
            <span className="italicSpan">
              {selectedCourse?.expiryDate} years
            </span>
          </p>
          <p>
            Price: <span className="italicSpan">${selectedCourse?.price}</span>
          </p>
          <p>{selectedCourse?.description}</p>
          {selectedCourse?.partTwo && (
            <p className="italicSpan p2">
              Part 2 practical training must be completed before a valid
              operator certificate can be issued. To scheudule training call or
              email us at: 902-478-1972 or hbenoit.yoda@outlook.com{' '}
            </p>
          )}
        </CourseInformation>
      )}
    </div>
  );
};
CourseList.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      description: PropTypes.string,
      expiryDate: PropTypes.string,
      price: PropTypes.number,
      partTwo: PropTypes.bool,
    })
  ),
  selectedCourse: PropTypes.shape({
    _id: PropTypes.string,
    courseName: PropTypes.string,
    description: PropTypes.string,
    expiryDate: PropTypes.string,
    price: PropTypes.number,
    partTwo: PropTypes.bool,
  }),
  setSelectedCourse: PropTypes.func,
};

export default CourseList;
